export const Bio = {
  name: "EL MAKHFI MOHAMED",
  roles: [
    "Software Engineer",
    "Full Stack Developer",
    "Java Developer",
    "Oracle Certified Professional",
  ],
  description:
    "Computer engineer and Software Engineer at Inventiv-IT, passionate about building robust web and backend solutions. Oracle Certified Professional in Java SE 21. Skilled in Java, Spring Boot, React, and cloud technologies, with a strong focus on clean architecture, performance, and best development practices.",
  github: "https://github.com/mohamedelmakhfi",
  resume:
    "https://firebasestorage.googleapis.com/v0/b/med-cloud-c4c79.appspot.com/o/EL_MAKHFI_MOHAMED_CV.pdf?alt=media&token=50804f0a-3257-400b-8782-af930000c697",
  linkedin: "https://www.linkedin.com/in/mohamed-elmakhfi-el2023/",
  twitter: "https://x.com/luka_simo10",
};

export const certifications = [
  {
    id: 0,
    name: "Oracle Certified Professional: Java SE 21 Developer",
    issuer: "Oracle",
    date: "June 2026",
    image: "/skills/oracle.svg",
    link: "https://catalog-education.oracle.com/ords/certview/sharebadge?id=F12962A057BA6B6B11E45F35C0B92DCF32749B971FA6D84B928B2FD06442AAED",
  },
];

export const skills = [
  {
    title: "Frontend",
    skills: [
      { name: "React Js", image: "/skills/react.svg" },
      { name: "Redux", image: "/skills/redux.svg" },
      { name: "TypeScript", image: "/skills/typescript.svg" },
      { name: "HTML5", image: "/skills/html5.svg" },
      { name: "CSS3", image: "/skills/css3.svg" },
      { name: "JavaScript", image: "/skills/javascript.svg" },
      { name: "Tailwind CSS", image: "/skills/tailwind.svg" },
      { name: "Bootstrap", image: "/skills/bootstrap.svg" },
      { name: "Material UI", image: "/skills/materialui.svg" },
      { name: "Angular", image: "/skills/angular.svg" },
    ],
  },
  {
    title: "Backend",
    skills: [
      { name: "Java 21", image: "/skills/java.svg" },
      { name: "Spring Boot", image: "/skills/spring.svg" },
      { name: "Spring Security", image: "/skills/spring.svg" },
      { name: "JPA / Hibernate", image: "/skills/hibernate.svg" },
      { name: "Node Js", image: "/skills/nodejs.svg" },
      { name: "Express Js", image: "/skills/express.svg" },
      { name: "MySQL", image: "/skills/mysql.svg" },
      { name: "MongoDB", image: "/skills/mongodb.svg" },
      { name: "Redis", image: "/skills/redis.svg" },
      { name: "Firebase", image: "/skills/firebase.svg" },
      { name: "REST APIs", image: "/skills/java.svg" },
      { name: "Maven", image: "/skills/maven.svg" },
      { name: "Google Cloud", image: "/skills/gcp.svg" },
    ],
  },
  {
    title: "Mobile",
    skills: [
      { name: "Kotlin", image: "/skills/kotlin.svg" },
      { name: "Android Studio", image: "/skills/androidstudio.svg" },
    ],
  },
  {
    title: "Tools & Others",
    skills: [
      { name: "Git", image: "/skills/git.svg" },
      { name: "GitHub", image: "/skills/github.svg" },
      { name: "Docker", image: "/skills/docker.svg" },
      { name: "VS Code", image: "/skills/vscode.svg" },
      { name: "IntelliJ IDEA", image: "/skills/intellij.svg" },
      { name: "Postman", image: "/skills/postman.svg" },
      { name: "Linux", image: "/skills/linux.svg" },
      { name: "Python", image: "/skills/python.svg" },
      { name: "Figma", image: "/skills/figma.svg" },
      { name: "Oracle", image: "/skills/oracle.svg" },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: "/assets/images/inventiv_it_logo.jpeg",
    role: "Software Engineer / Developer",
    company: "Inventiv-IT",
    date: "January 2026 - Present",
    desc: "Software Engineer at Inventiv-IT, developing and maintaining enterprise web applications with modern technologies. Contributing to full-stack solutions, code quality, and collaborative agile workflows.",
    tasks: [
      "Development of full-stack web applications with Java, Spring Boot, and React.",
      "Design and implementation of RESTful APIs and microservices.",
      "Collaboration on software architecture and performance optimization.",
      "Participation in code reviews, testing, and deployment pipelines.",
      "Working with cloud services and modern development tools.",
    ],
    skills: [
      "Java 21",
      "Spring Boot",
      "React.js",
      "TypeScript",
      "Docker",
      "Git",
      "GitHub",
      "REST APIs",
    ],
  },
  {
  id: 1,
  img: "/assets/images/D%26A.jpeg",
  role: "Final-Year Internship at D&A Technologies",
  company: "D&A Technologies",
  date: "February 2025 - July 2025",
  desc: "Contribution à l’ajout de nouveaux canaux de réseaux sociaux à la plateforme Cezium AdZ, tout en contribuant à l’amélioration de l’expérience utilisateur et des fonctionnalités existantes.",
  tasks: [
    "Développement de nouvelles intégrations pour les réseaux sociaux dans Cezium AdZ.",
    "Amélioration de l’interface utilisateur avec Thymeleaf, JavaScript et CSS.",
    "Participation aux développements backend en Java 21 avec Spring Boot.",
    "Utilisation de Google Cloud Platform pour le déploiement et les services cloud.",
    "Collaboration en équipe avec Git, GitHub et suivi des tickets.",
    "Contribution aux campagnes marketing via Salesforce Marketing Cloud."
  ],
  skills: ["Java 21", "Spring Boot", "GCP", "Thymeleaf", "JavaScript", "CSS", "Git", "GitHub", "Salesforce Marketing Cloud"],
},
  {
    id: 2,
    img: "/assets/images/deltalink_maroc_logo.jpeg",
    role: "Intern at DeltaLink",
    company: "DeltaLink",
    date: "July 2024 - August 2024",
    desc: "Development of an innovative platform connecting clients with qualified service providers. This project facilitates interaction between users and providers, offering an intuitive solution for posting needs and managing requests.",
    tasks: [
      "Designed and developed responsive user interfaces with React.js and Material-UI.",
      "Developed the backend with Spring Boot to manage application operations.",
      "Implemented Spring Data for data management.",
      "Set up authentication and security with Spring Security.",
      "Managed user roles for appropriate access control.",
      "Conducted functional testing to ensure application quality.",
      "Collaborated with the team to integrate different features and optimize performance.",
    ],
    skills: [
      "React.js",
      "Spring Boot",
      "Spring Data",
      "Spring Security",
      "Material-UI",
      "Git",
      "Postman",
      "IntelliJ",
    ],
  },
  {
    id: 3,
    img: "/assets/images/yane%20code.jpeg",
    role: "Internship at YaneCode",
    company: "YaneCode",
    date: "July 2024 - August 2024",
    desc: "Development of an 'Online Resume Builder', a web application that allows users to easily create professional CVs. The application offers customization features, live preview, and export options in PDF format.",
    tasks: [
      "Designed and developed the user interface with React.js for a smooth and intuitive experience.",
      "Integrated Firebase for user data management and authentication.",
      "Set up CV customization features, allowing users to choose templates and styles.",
      "Developed the live preview feature to enable users to see changes instantly.",
      "Implemented CV export functionality in PDF and Word formats.",
    ],
    skills: ["React.js", "Firebase", "Git", "Postman", "Visual Studio Code"],
  },

];

export const education = [
  {
    id: 0,
    img: "/assets/images/imam%20ghazali.jpeg",
    school: "Imam El Ghazali High School",
    date: "2019",
    grade: "Baccalauréat, Physics Option",
    desc: "Obtained the Baccalauréat with a specialization in Physics.",
    degree: "Baccalauréat",
  },
  {
    id: 1,
    img: "/assets/images/faculte.png",
    school: "Faculty of Sciences of Rabat",
    date: "2020",
    grade: "Branch of Physical Sciences",
    desc: "Studied Physical Sciences at the Faculty of Sciences of Rabat.",
    degree: "Bachelor's Degree in Physical Sciences",
  },
  {
    id: 2,
    img: "/assets/images/ensa%20safi.jpeg",
    school: "National School of Applied Sciences of Safi",
    date: "2021 - 2025",
    grade: "Engineering Cycle in Computer Engineering",
    desc: "Currently pursuing an engineering degree in Computer Science at ENSA Safi.",
    degree: "Engineering Degree in Computer Science",
  },
  {
    id: 3,
    img: "/assets/images/yane%20code.jpeg",
    school: "YaneCode Academy",
    date: "October 2022 - December 2022",
    grade: "Full-Stack Developer",
    desc: "Certified training in full-stack development.",
    degree: "Certification in Full-Stack Development",
  },
];

export const projects = [
  {
    id: 0,
    title: "ENSALINK – Social Platform for ENSAS Clubs",
    date: "Feb 2024 - May 2024",
    description:
      "Developed ENSALINK, a social networking platform dedicated to students at ENSA Safi. The platform allows students to post, interact with clubs, and participate in events via an intuitive interface.",
    tasks: [
      "Implemented secure and contextual authentication using JWT and Passport.js.",
      "Designed and developed user role management with an intuitive interface.",
      "Configured email notification systems and password reset functionality using Nodemailer.",
      "Collaborated with the team to integrate back-end modules with a smooth and responsive user interface."
    ],
    image: "/assets/images/ensa%20link.jpeg",
    tags: ["MongoDB", "Express.js", "React", "Node.js", "Redux", "Tailwind CSS", "JWT", "Passport.js", "Nodemailer"],
    category: "web app",
    github: "https://github.com/mohamedelmakhfi/ENSA_LINK_PROJET",
    member: [
      {
        name: "Mohamed El Makhfi",
        img: "/assets/images/mohamed.jpeg",
        linkedin: "https://www.linkedin.com/in/mohamed-elmakhfi-el2023/",
        github: "https://github.com/mohamedelmakhfi",
      },
      {
        name: "Abdesslam Zennou",
        img: "/assets/images/dev.png",
        linkedin: "https://www.linkedin.com/in/abdessalam-zennou?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3Bv%2BE0qTGMQOurY3oHAe34pQ%3D%3D",
        github: "https://github.com/AbdessalamZENNOU",
      },
      {
        name: "Anass Khanous",
        img: "/assets/images/dev.png",
        linkedin: "https://www.linkedin.com/in/anass-khannous-922515193/",
        github: "https://github.com/33N3S",
      },
    ],
  },
  {
    id: 1,
    title: "Innovative Hospital Management Platform",
    date: "Feb 2023 - May 2023",
    description:
      "Developed an innovative hospital management platform aimed at centralizing operations and improving decision-making processes in healthcare institutions.",
    tasks: [
      "Designed and developed the user interface using React.js and Material-UI.",
      "Implemented backend with Spring Boot to handle healthcare institution operations.",
      "Optimized management processes and decision-making workflows."
    ],
    image: "/assets/images/innovation%20hospital.jpeg",
    tags: ["React.js", "CSS", "Material-UI", "Spring Boot", "MySQL", "Git"],
    category: "web app",
    github: "https://github.com/mohamedelmakhfi/",
    member: [
      {
        name: "Mohamed El Makhfi",
        img: "/assets/images/mohamed.jpeg",
        linkedin: "https://www.linkedin.com/in/mohamed-elmakhfi-el2023/",
        github: "https://github.com/mohamedelmakhfi",
      },
      {
        name: "Anass Khanous",
        img: "/assets/images/dev.png",
        linkedin: "https://www.linkedin.com/in/anass-khannous-922515193/",
        github: "https://github.com/33N3S",
      },
      {
        name: "Fatima Ezzahra Amrani",
        img: "/assets/images/dev.png",
        linkedin: "https://www.linkedin.com/in/fatima-zahra-el-amrani-937136224?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3Bsk1q%2BalrTqi2H6kjUlSQfA%3D%3D",
        github: "https://github.com/fatimaezzahraamrani",
      }
    ]
  },
  {
    id: 2,
    title: 'The development of the innovative project "9diLiGharad".',
    date: "Jul 2024 - Aug 2024",
    description:
      "Developed a dynamic platform connecting clients with qualified service providers. This project facilitates interaction between users and providers, offering an intuitive solution for publishing needs and managing requests.",
    tasks: [
      "Designed and developed responsive user interfaces using React.js and Material-UI.",
      "Developed backend using Spring Boot to handle application operations.",
      "Implemented Spring Data for data management.",
      "Set up authentication and security with Spring Security.",
      "Managed user roles to ensure appropriate access control.",
      "Conducted functional testing to ensure application quality.",
      "Collaborated with the team to integrate various features and optimize performance."
    ],
    image:
      "https://firebasestorage.googleapis.com/v0/b/med-cloud-c4c79.appspot.com/o/qdiligharad.png?alt=media&token=6ebbe511-f7bc-41d0-92c7-4b325ef14a9e",
    tags: ["React.js", "Spring Boot", "Spring Data", "Spring Security", "Material-UI", "Git", "Postman", "IntelliJ"],
    category: "web app",
    github: "https://github.com/mohamedelmakhfi/",
    member: [
      {
        name: "Mohamed El Makhfi",
        img: "/assets/images/mohamed.jpeg",
        linkedin: "https://www.linkedin.com/in/mohamed-elmakhfi-el2023/",
        github: "https://github.com/mohamedelmakhfi",
      },
      {
        name: "Abdelhadi Zennou",
        img: "/assets/images/dev.png",
        linkedin: "https://www.linkedin.com/in/abdelhadi-zennou-b769361b0/",
        github: "https://github.com/",
      },
      {
        name: "Hassan Outhami",
        img: "/assets/images/dev.png",
        linkedin: "https://www.linkedin.com/in/outhami-hassan/",
        github: "https://github.com/",
      }
    ]
  }, 
  {
    id: 3,
    title: "Dynamic Blog with MERN Stack",
    date: "Oct 2023 - Dec 2023",
    description:
      "Developed a dynamic blog using the MERN stack, featuring post publishing and editing functionalities with JWT-based authentication for managing user sessions and security.",
    tasks: [
      "Designed the database architecture using MongoDB.",
      "Developed a RESTful API to manage posts and users.",
      "Created a smooth user interface using React.js for an enhanced user experience.",
      "Implemented route protection with JWT for authentication and session management.",
      "Conducted functional testing to ensure the quality and reliability of the blog."
    ],
    image: "/assets/images/blog%20mern.jpeg",
    tags: ["MongoDB", "Express.js", "React.js", "Node.js", "JWT"],
    category: "web app",
    github: "https://github.com/mohamedelmakhfi/Blog-MERN",
    member: [
      {
        name: "Mohamed El Makhfi",
        img: "/assets/images/mohamed.jpeg",
        linkedin: "https://www.linkedin.com/in/mohamed-elmakhfi-el2023/",
        github: "https://github.com/mohamedelmakhfi",
      },
    ]
  },
  {
    id: 4,
    title: "Online Resume Builder",
    date: "Jul 2024 - Aug 2024",
    description:
      "Developed an 'Online Resume Builder', a web application that allows users to easily create professional resumes. The app offers customization options, live preview, and export functionality in PDF and Word formats.",
    tasks: [
      "Designed and developed a smooth and intuitive user interface using React.js.",
      "Integrated Firebase for user data management and authentication.",
      "Implemented resume customization features, enabling users to select templates and styles.",
      "Developed live preview functionality to allow users to see changes instantly.",
      "Implemented resume export functionality in PDF and Word formats."
    ],
    image:
      "https://firebasestorage.googleapis.com/v0/b/med-cloud-c4c79.appspot.com/o/resume.png?alt=media&token=85524169-9454-4bd7-9682-f0d53e9ec021",
    tags: ["React.js", "Firebase", "PDF Export", "Word Export"],
    category: "web app",
    github: "https://github.com/mohamedelmakhfi/ResumeYane",
    member: [
      {
        name: "Mohamed El Makhfi",
        img: "/assets/images/mohamed.jpeg",
        linkedin: "https://www.linkedin.com/in/mohamed-elmakhfi-el2023/",
        github: "https://github.com/mohamedelmakhfi",
      },
    ]
  } ,
  {
    id: 5,
    title: "Collaborative Android News App",
    date: "2024",
    description:
      "Developed 'Nomad News', an Android application that merges innovation with collaboration. The app offers users a personalized news feed, intuitive UI/UX, and features like saved articles and profile customization, following the MVVM architecture and DataBinding techniques.",
    tasks: [
      "Collaborated with a diverse team to develop a dynamic Android news app.",
      "Implemented MVVM architecture for clean, maintainable code and streamlined development.",
      "Utilized DataBinding to dynamically bind UI components to data sources, enhancing UI efficiency.",
      "Developed features such as a personalized news feed, saved articles, and in-app navigation for a seamless user experience.",
      "Designed and implemented personalized profiles to tailor users' news feeds based on their preferences."
    ],
    image: "/assets/images/app%20mobile.jpeg",
    tags: ["Android", "MVVM", "DataBinding", "News App", "Java", "Kotlin"],
    category: "android app",
    github: "https://github.com/mohamedelmakhfi/",
    member: [
      {
        name: "Mohamed El Makhfi",
        img: "/assets/images/mohamed.jpeg",
        linkedin: "https://www.linkedin.com/in/mohamed-elmakhfi-el2023/",
        github: "https://github.com/mohamedelmakhfi",
      },
      {
        name: "Abdesslam Zennou",
        img: "/assets/images/dev.png",
        linkedin: "https://www.linkedin.com/in/abdessalam-zennou?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3Bv%2BE0qTGMQOurY3oHAe34pQ%3D%3D",
        github: "https://github.com/AbdessalamZENNOU",
      },
      {
        name: "Anass Khanous",
        img: "/assets/images/dev.png",
        linkedin: "https://www.linkedin.com/in/anass-khannous-922515193/",
        github: "https://github.com/33N3S",
      },
    ]
  },
  {
  "id": 6,
  "title": "AI Resume Analyzer",
  "date": "July 2025 - Oct 2025",
  "description": "Built an AI-powered Resume Analyzer using React, Tailwind CSS, TypeScript, and Puter.js. Implemented client-side authentication, resume uploads, and AI-based ATS scoring with tailored feedback, all in a reusable and responsive UI.",
  "tasks": [
    "Implemented seamless authentication and storage using Puter.js.",
    "Built AI resume matching to provide ATS scores and custom feedback.",
    "Developed a clean, reusable UI with React and Tailwind CSS.",
    "Ensured cross-device compatibility with responsive design.",
    "Followed modular code architecture for code reusability and maintainability."
  ],
  "image": "/assets/images/ai%20resume.jpeg",
  "tags": ["React", "Tailwind CSS", "TypeScript", "Puter.js", "Zustand"],
  "category": "web app",
  "github": "https://github.com/mohamedelmakhfi/ai-resume-analyser",
  "website": "https://ai-resume-analyser-med.vercel.app/auth?next=/", 
  "member": [
    {
        name: "Mohamed El Makhfi",
        img: "/assets/images/mohamed.jpeg",
        linkedin: "https://www.linkedin.com/in/mohamed-elmakhfi-el2023/",
        github: "https://github.com/mohamedelmakhfi"
    }
  ]
}

];
